import { createSelector } from '@reduxjs/toolkit';

import { FeatureName } from '@/types/app-configurations';

import { checkUserEkycStatus, isEkycStatusComplete } from '@/utils/user';

import { RootState } from '../store';

export const selectAuthState = createSelector(
  (state: RootState) => state.auth,
  data => ({ ...data }),
);

export const selectLoggedInUser = createSelector(
  (state: RootState) => state.auth,
  data => data.user,
);

export const selectIsIdentityChecked = createSelector(
  [
    selectLoggedInUser,
    (state: RootState) =>
      !!state.configs.features.find(
        item => item.feature === FeatureName.DisableLivenessRecord,
      ),
  ],
  (user, isRecordDisabled) => {
    if (!user) return false;
    return isEkycStatusComplete(checkUserEkycStatus(user), isRecordDisabled);
  },
);
